import { render, staticRenderFns } from "./OrdenDetail.vue?vue&type=template&id=8a83ee30&"
import script from "./OrdenDetail.vue?vue&type=script&lang=js&"
export * from "./OrdenDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrdenDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports